import React from 'react';
import { mainContainerStyle } from './aligner-layout-style';
interface Props { children?: Array<JSX.Element> | JSX.Element; }
const MainContainerLayout: React.FC<Props> = ({children}): JSX.Element => (
  <div
    style={mainContainerStyle}
  >{children}</div>
);

export default MainContainerLayout;